import { FSFileList, mapFSFileLists } from "../FileList";

/* **************************************************** Finishing Shedule Tile Data */
export interface FSTileData {
    id: number;
    fs_data_id: number;
    type_id: number | null;
    shop_id: number | null;
    color_id: number | null;
    name: string | null;
    link: string | null;
    quantity: number | null;
    size: number | null;
    image_path: string | null;
    file_list: FSFileList[];
}

export const mapFSTileData = (data: any): FSTileData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSTileData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        type_id: data.type_id || null,
        shop_id: data.shop_id || null,
        color_id: data.color_id || null,
        name: data.name || null,
        link: data.link || null,
        quantity: data.quantity || null,
        size: data.size || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
    };

    return res;
};

export const mapFSTileDatas = (data: any[]): FSTileData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSTileData);
};


/* **************************************************** Finishing Shedule Tile */
export interface FSTile {
    id: number;
    fs_feature_id: number;
    category: string | null;
    location_name: string | null;
    location_id: number | null;
    data_tile: FSTileData[];
}

export const mapFSTile = (data: any): FSTile => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSTile = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category || null,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        data_tile: Array.isArray(data.data_tile) ? mapFSTileDatas(data.data_tile) : [],
    };

    return res;
};

export const mapFSTiles = (data: any[]): FSTile[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSTile);
};
